import React,{Component} from 'react';
import { ref } from '../config/constants'
import moment from 'moment'


class ReturnProduct extends Component{
    constructor(){
        super();
        this.handleChange = this.handleChange.bind(this);
        this.saveToInventory = this.saveToInventory.bind(this);
        this.handleName = this.handleName.bind(this);
        this.state ={
            categoryList : {},
            inventoryList: {},
            productsList : {},
            productName :""
        }
    }

    componentDidMount() {

        var category = ref.child("Categories")
            category.on("value", function(snap){
                this.setState({
                    categoryList : snap.val()
                })
            }.bind(this)) 

         var inventory = ref.child("Inventory").child("Products")
            inventory.on("value", function(snap){
                this.setState({
                    inventoryList : snap.val()
                })
            }.bind(this))       
    }

    handleChange(e){
        let products = ref.child("Products").orderByChild("category").equalTo(this.category.value)
                products.on("value",function(snap){
                    
                    this.setState({
                        productsList : snap.val()
                    })

                }.bind(this))
    }

    handleName(e){
        let products = ref.child("Products").child(this.product.value)
                products.on("value",function(snap){
                    
                    this.setState({
                        productName : snap.val().name
                    })

                }.bind(this))
        //console.log(this.state.productName)
    }

    saveToInventory(e){
        e.preventDefault()
        if(!this.state.inventoryList){
            let data={
                    product_Id : this.product.value,
                    product_color : this.color.value,
                    product_length : this.length.value,
                    product_count : parseInt(this.count.value,10),
                    product_name : this.state.productName
                }
            let stockIn={
                    status: "In",
                    product_Id : this.product.value,
                    product_count : this.count.value,
                    product_length : this.length.value,
                    product_name : this.state.productName,
                    date : moment().format("MM DD YYYY"),
                    product_color : this.color.value
                }
                ref.child("Inventory").child("Products").push(data).then(alert("Products has been returned"))
                ref.child("StockCard").child("Products").push(stockIn)
        }else{
            var exist = false
            var productKey = ""
            var productCount = 0
            Object.keys(this.state.inventoryList).map(key => {
                let list = this.state.inventoryList[key]
                if(list.product_Id === this.product.value && list.product_color === this.color.value && list.product_length === this.length.value){
                    exist = true
                    productKey = key
                    productCount = list.product_count                
                }  
            })

            if(exist === true){
                let count = productCount + parseInt(this.count.value,10)
                let update = {
                        product_count : count
                    }
                let stockIn={
                    status: "In",
                    product_Id : this.product.value,
                    product_count : this.count.value,
                    product_length : this.length.value,
                    product_name : this.state.productName,
                    date : moment().format("MM DD YYYY"),
                    product_color : this.color.value
                }
                ref.child("Inventory").child("Products").child(productKey).update(update).then(alert("Products has been returned"))
                ref.child("StockCard").child("Products").push(stockIn)
            }else{
                let data={
                    product_Id : this.product.value,
                    product_color : this.color.value,
                    product_length : this.length.value,
                    product_count : parseInt(this.count.value,10),
                    product_name : this.state.productName
                }
                let stockIn={
                    status: "In",
                    product_Id : this.product.value,
                    product_count : this.count.value,
                    product_length : this.length.value,
                    product_name : this.state.productName,
                    date : moment().format("MM DD YYYY"),
                    product_color : this.color.value
                }
                ref.child("Inventory").child("Products").push(data).then(alert("Products has been returned"))
                ref.child("StockCard").child("Products").push(stockIn)
            }
        }
        this.formSubmit.reset()
    }

    
          
    render() {

        return (
            <div className="row">
                <form ref={input => this.formSubmit = input} onSubmit={this.saveToInventory}>
                <div className="row">
                    <div className="col-md-6">
                        <div className="">
                            <select className="form-control" ref={ input => this.category = input} onChange={this.handleChange} require>
                                <option>Select Category</option>
                                { 
                                    this.state.categoryList &&
                                    Object.keys(this.state.categoryList).map(function (key){
                                        let list = this.state.categoryList[key]
                                        return <option value={list.category} key={key}> {list.category} </option>
                                   }.bind(this))
                                }
                            </select>
                        </div>

                        <div className="">
                            <select className="form-control col-md-3"  ref={ input => this.product = input } onChange={this.handleName} require>
                                <option>Select Products</option>
                                { 
                                    this.state.productsList &&
                                    Object.keys(this.state.productsList).map(function (key){
                                        let list = this.state.productsList[key]

                                        if(list.status==="Active"){
                                            return <option value={key} key={key}> {list.name} </option>
                                        }else{
                                            return false;
                                        }
                                   }.bind(this))
                                }
                            </select>
                        </div>
                        <div className="">
                            <select className="form-control" name="length" ref={ input => this.length=input }  require>
                                <option>Select Length</option>
                                <option value="2.44 M">2.44 M</option>
                                <option value="4.55 M">4.55 M</option>
                            </select>                        
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="">
                            <select className="form-control" name="color" ref={ input => this.color=input } require>
                                <option>Select Color</option>
                                <option value="red">red</option>
                                <option value="gray">gray</option>
                                <option value="black">black</option>
                                <option value="blue">blue</option>
                            </select>
                        </div>

                        <div className="">
                            <div className="row">
                                <div className="col-md-4 forLabelInput">
                                    <p>Enter Quantity</p>
                                </div>     
                                <div className="col-md-8">
                                    <input type="text" className="form-control col-md-3 forQty" name="count" defaultValue = {0}
                                     ref={ input => this.count = input } required/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="genButtonHolder">
                    <button type="submit" className="btn btn-sm btn-danger" >Save</button> 
                </div>
                </form>  
            </div>
        );
    }
}

export default  ReturnProduct;



// WEBPACK FOOTER //
// ./src/components/ReturnProduct.js